import React from "react";
import { Colors } from "../../../utils/colors";

type props = {
  index: number;
};

export const MatchIndex: React.FC<props> = ({ index }) => {
  return (
    <div
      style={{
        background: Colors.green,
        color: Colors.white,
        borderRadius: "50%",
        width: 20,
        height: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        fontSize: 12,
        marginRight: 8,
      }}>
      {index + 1}
    </div>
  );
};
